import useLiveChatDeepLink from 'components/LiveChat/useLiveChatDeepLink';

/**
 * Invisible mount component for the LiveChat deep-link feature. It runs
 * `useLiveChatDeepLink()` and renders nothing. Mounted once at the app root so
 * the deep-link is evaluated on every page load.
 *
 * Named `...Mount` to avoid a case-insensitive filesystem collision with the
 * lowercase helper module `liveChatDeepLink.js`.
 */
const LiveChatDeepLinkMount = () => {
  useLiveChatDeepLink();

  return null;
};

export default LiveChatDeepLinkMount;
